import './style.scss';
import {
    FacebookLogo,
    InstagramLogo,
    LinkedinLogo,
    NumeezyLogo,
} from '../../../assets/About';

export default {
    name: 'mainHeader',
    metaInfo: {
        titleTemplate: '%s | À propos',
    },
    data() {
        return {
            assets: {
                FacebookLogo,
                InstagramLogo,
                LinkedinLogo,
                NumeezyLogo,
            },
        };
    },
    mounted() {
        this.$emit('showConferenceBanner', false);
        this.changeHeader();
    },
    methods: {
        changeHeader() {
            const header = document.querySelector('#banner');

            header.classList.add('flex-col');
            header.innerHTML = `
                <p class="leading-normal pb-5 lg:pb-10 text-center">
                    Pour en <span class="font-bold text-primary">savoir plus</span> sur nous !
                </p>
                <p class="text-base text-center">À propos</p>`;
        },
    },
};
